/* The shop's own pages (products, cart, account and the rest) are plain
   HTML. This shows the cookie notice there until a choice is made, as the
   tube does on the ECHOE pages; consent.js keeps the choice. */

import { consent, known, decide } from "./consent.js";

const notice = document.getElementById("cookie");
const box = document.getElementById("cookie-analytics");

if (notice && box) {
  known.then(() => {
    box.checked = consent.choice === true;
    if (consent.choice === null) notice.hidden = false;
  });

  notice.addEventListener("click", (e) => {
    const button = e.target.closest("button[data-consent]");
    if (!button) return;
    const k = button.dataset.consent;
    decide(k === "accept" ? true : k === "reject" ? false : box.checked);
    notice.hidden = true;
  });
}

/* A product page: the price and the button follow the variant picked, and
   the address keeps it, so a reload or a shared link opens the same one. */
const picker = document.getElementById("ProductVariant");
if (picker) {
  const button = document.getElementById("ProductAdd");
  const price = document.querySelector("#ProductPrice .price");
  picker.addEventListener("change", () => {
    const o = picker.selectedOptions[0];
    const open = o.dataset.available === "true";
    button.disabled = !open;
    button.textContent = open ? button.dataset.add : button.dataset.soldOut;
    if (price) {
      price.replaceChildren();
      if (o.dataset.compare) {
        const now = document.createElement("ins");
        const was = document.createElement("del");
        now.textContent = o.dataset.price;
        was.textContent = o.dataset.compare;
        price.append(now, " ", was);
      } else {
        price.textContent = o.dataset.price;
      }
    }
    const url = new URL(location.href);
    url.searchParams.set("variant", o.value);
    history.replaceState(history.state, "", url);
  });
}

/* Suggestions under a product, which Shopify only fills in on request. */
for (const box of document.querySelectorAll(".recommendations[data-url]")) {
  fetch(box.dataset.url)
    .then((r) => (r.ok ? r.text() : ""))
    .then((html) => {
      const got = new DOMParser().parseFromString(html, "text/html").querySelector(".recommendations");
      if (got && got.children.length) box.replaceChildren(...got.children);
    })
    .catch(() => {});
}

/* Address forms: the saved country picked, and its provinces listed (Shopify
   puts them on each country's option), the province list hidden for a
   country that has none. */
for (const country of document.querySelectorAll("select[data-provinces-for]")) {
  const province = document.getElementById(country.dataset.provincesFor);
  const label = province && document.querySelector(`label[for="${province.id}"]`);
  if (country.dataset.default) country.value = country.dataset.default;
  const fill = () => {
    let list = [];
    try { list = JSON.parse(country.selectedOptions[0]?.dataset.provinces || "[]"); } catch (_) {}
    province.replaceChildren(...list.map(([value, name]) => new Option(name, value)));
    if (province.dataset.default) province.value = province.dataset.default;
    province.hidden = label.hidden = list.length === 0;
  };
  if (province && label) {
    fill();
    country.addEventListener("change", () => { province.dataset.default = ""; fill(); });
  }
}

/* A button that undoes something asks first. */
document.addEventListener("submit", (e) => {
  const ask = e.submitter && e.submitter.dataset.confirm;
  if (ask && !window.confirm(ask)) e.preventDefault();
});
